import React, { Component } from 'react';
import StockList from '../list/StockList';
import { Grid, Box, Table, TableRow, TableBody, TableCell, Typography, Button } from '@material-ui/core';
import PreviewLoc from '../localisations/PreviewLoc';
import { isEmpty } from 'lodash-es';
import PopUp from '../../../../commonModules/interface/PopUp';


class SingleShop extends Component {
    state = {
        logo:"",
        stockList: this.props.list || "AVAILABLE",
        local:{}
    }
    componentDidMount = async () =>{
        console.log("[INFO] MOUNTING SHOP SINGLE ");
        // const { shop } = this.props

        // if(shop.logo && !shop.src){
        //     this.props.getPhoto(shop.id, shop.logo.filename)
        // }
        // TODO :
        // check shop plans exist
    //     this.getShopLocal()
    // }
    // getShopLocal = async () => {
        let req = await fetch("/stocks/locals/shop",{
            method:"POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({shopID: this.props.shop.id}),
            credentials: 'same-origin',
        })
        let res = await req.json()

        console.log("getShopLocal", {res});
        if(res.error){
            console.log("getShopLocal", res.error.error);
        } else {
            this.setState({
                local: res
            })    
        }
    }

    fields = () => {
        const shop = this.props.shop
        const match = {
            "Référence: ":shop.shop_ref,
            "Adresse: ":shop.address,
            "Ville: ":shop.city,
            "Pays: ":shop.country,

        }
        return Object.keys(match).map((field, i) => {            
            return(  
                <TableRow key={i}>
                    <TableCell>{field}</TableCell><TableCell>{match[field]}</TableCell>
                </TableRow>
            )
        })
    }

    openLocalMap = () => {
        this.setState({
            openLocal : true
        })
    }
    render(){
        const { shop } = this.props;
        const { openLocal, local } = this.state;

        return(
        
            <Box container spacing={2}>
                {/* <Grid item md={3} xs={12}>
                    {this.props.shop.logo &&
                    <div className="logo">
                        <img src={`/stocks/photos/${this.props.shop.logo.filename}`} alt=""/>
                    </div>
                    }
                </Grid>
                    
                <Grid item md={9} xs={12}>
                    <Box p={2}>      
                        <Table className="table">
                            <TableBody>
                                {this.fields()}
                            </TableBody>
                        </Table> 
                    </Box>
                </Grid> */}
                {openLocal &&
                    <PopUp
                        title={`Plan du magasin ${shop.name}`}
                        close={() => this.setState({openLocal: false})}
                        appbar
                    >
                        <PreviewLoc
                            {...this.state.local}
                        />
                    </PopUp>
                }
                <Box p={3}>
                    {shop.logo &&
                    <Box className="logo">
                        <img src={`/stocks/photos/${shop.logo.filename}`} alt=""/>
                    </Box>
                    }
                    <Box>
                        <Typography variant="h5"><b>{shop.name}</b></Typography>
                        <Typography variant="body1"><b>{shop.shop_ref}</b></Typography>
                        {shop.tel && <Typography variant="body2">{shop.tel} </Typography> }
                        {shop.email && <Typography variant="body2">{shop.email} </Typography> }
                        <Typography variant="body2">{shop.address}</Typography>
                        <Typography variant="body2">{shop.city} - {shop.country}</Typography>
                    </Box>
                    {!isEmpty(local) &&
                    <Box p={2}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => this.openLocalMap()}
                        >
                            Voir le plan
                        </Button>
                    </Box>  
                    }
                </Box>
                <Box>
                    {/* <StockList where="shop_id" filter={this.props.shop.id} {...this.props} /> */}
                    <StockList where="shop_id" filter={this.props.shop.id} {...this.props} />
                </Box>
            </Box>
                
        )
    }
}

export default SingleShop